import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import BluebirdPromise from 'bluebird';
import { Form, reduxForm, Field, formValueSelector, submit } from 'redux-form';
import cns from 'classnames';
import { get } from 'lodash';
import { compose } from 'redux';
import BasicSearchText from '../../components/formComponents/groups/BasicSearchText';
import log from '../../utils/log';
import WithTranslation from '../../hocs/WithTranslation';
import { RuntimeContext } from '../../../../common/RuntimeContext';
import algolia from 'algoliasearch';
import { getSearchKey } from '../../actions';

class SearchForm extends Component {
    static propTypes = {
        className: PropTypes.string,
        searchClassName: PropTypes.string,
        handleSubmit: PropTypes.func.isRequired,
        attributesToRetrieve: PropTypes.array,
        handleSearchResults: PropTypes.func,
        onClearSearch: PropTypes.func,
        indexName: PropTypes.string.isRequired,
        placeholder: PropTypes.string,
        attributesToHighlight: PropTypes.array,
        showBottomBorder: PropTypes.bool,
        showCurrentSearchCriteria: PropTypes.bool,
        shouldInit: PropTypes.bool,
        showFullBorder: PropTypes.bool,
        defaultFilters: PropTypes.string,
        keyId: PropTypes.string.isRequired,
    };

    static contextType = RuntimeContext

    constructor(props) {
        super(props);
        this.state = { searchValue: '', isLoading: false  };
        this.index = {};
        this.algoliaInstance = {};
        this.intervalID = ''
    }

    componentDidMount() {
        this.setState({isLoading: true});
        this.getKey().then(() => {
            if (this.props.shouldInit) {
              this.handleFormSubmit({ searchVal: ' ' });
            }
          });
          this.intervalID = setInterval(this.getKey, 3600000);
    }

    componentWillUnmount() {
        clearInterval(this.intervalID);
      }

    getKey = () => getSearchKey({id: this.props.keyId }, this.context.pathsWeb).then(searchKey => {
        this.algoliaInstance = algolia(this.context.pathsWeb.algoliaAppID, searchKey)
        this.index = this.algoliaInstance.initIndex(this.props.indexName);
        this.setState({isLoading: false});
    });

    handleFormSubmit = (values) => {
        const {
            handleSearchResults,
            defaultFilters,
            attributesToRetrieve = ['_id'],
            attributesToHighlight = []
        } = this.props;

        let searchResultPromise = BluebirdPromise.resolve();
        const searchValue = get(values, 'searchVal', '');
        const filtersValue = get(values, 'filters', '');
        if (searchValue !== '' || filtersValue !== '') {
            const searchOptions = {
                attributesToRetrieve,
                attributesToHighlight,
                hitsPerPage: 1000
            };

            if (defaultFilters) {
                searchOptions.filters = defaultFilters;
            }

            if (filtersValue) {
                searchOptions.filters = filtersValue;
            }
            searchResultPromise = this.index.search(searchValue, searchOptions).then((result) => result.hits);
        }

        return searchResultPromise.then((hits) => {
            const results = hits || [];
            if (handleSearchResults) {
                this.setState({ searchValue });
                handleSearchResults(results);
            } else {
                log.warn(
                    'SearchForm.props.handleSearchResults is highly recommended since results are not being piped anywhere!'
                );
            }
        });
    };

    _onClear = () => {
        if (this.props.onClearSearch) {
            this.props.onClearSearch();
        }
    };

    render() {
        const {
            handleSubmit,
            placeholder = '',
            searchClassName,
            className,
            showBottomBorder = true,
            showFullBorder = false,
            showCurrentSearchCriteria = false,
            autoUpdateField = true,
        } = this.props;
        const { searchValue = null, isLoading } = this.state;

        const isLoadingForm = isLoading ? 'search-form-disabled' : '';
        return (
            <Form
                className={cns('col-12', { searchForm: !showFullBorder }, { 'bordered-search-form': showFullBorder })}
                onSubmit={handleSubmit(this.handleFormSubmit)}
            >
                <Field
                    name={'searchVal'}
                    displayHelp={false}
                    className={cns('searchInput', className, isLoadingForm)}
                    searchClassName={searchClassName}
                    showBottomBorder={showBottomBorder}
                    placeholder={placeholder}
                    onClear={this._onClear}
                    onSubmit={this._onSubmit}
                    onChange={autoUpdateField ? handleSubmit(this.handleFormSubmit) : () => {}}
                    component={BasicSearchText}
                    disabled={isLoading}
                />
                {showCurrentSearchCriteria && searchValue ? (
                    <div className={'searchResultsText'}>Search results for {`"${searchValue}"`}</div>
                ) : null}
            </Form>
        );
    }
}

export const SearchFormComponent = SearchForm;

const SearchFormValidation = {
    form: 'SearchForm'
};

const selector = formValueSelector('SearchForm');
const mapStateToProps = (state, ownProps) => ({
    initialValues: {
        filters: get(ownProps, 'precomputedFilters', '')
    },
    searchVal: selector(state, 'searchVal')
});

const mapDispatchToProps = (dispatch) => ({
    submitSearch: () => dispatch(submit('SearchForm'))
});

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    reduxForm(SearchFormValidation)
)(WithTranslation(SearchForm));
